import "../styles/App.css";
import Header from "./Header";
import Body from "./Body";
import React from "react";
import IntroPage from "./IntroPage";
import ProjectsPage from "./ProjectsPage";
import ContactPage from "./ContactPage";

import { Helmet } from 'react-helmet'

import {
  BrowserRouter as Router,
  Routes,
  Route
} from "react-router-dom";
import AboutPage from "./AboutPage";


const TITLE = "DURBO";

export default function App() {
  return (
    <Router>
        <Header/>
        <Routes>
            <Route path="/" element={<Home/>}/>
            <Route path="/about" element={<About/>}/>
            <Route path="/projects" element={<Projects/>}/>
            <Route path="/contact" element={<Contact/>}/>
          </Routes>
    </Router>
  );
}

function Home() {
  return (
      <Body>
        <Helmet>
          <title>{TITLE}</title>
        </Helmet>
        <IntroPage/>
      </Body>
    
  );
}

function About() {
  return (
    <Body>
      <Helmet>
          <title>{TITLE} | About</title>
      </Helmet>
      <AboutPage/>
    </Body>);
}

function Projects() {
  return (
    <Body>
      <Helmet>
          <title>{TITLE} | Projects</title>
      </Helmet>
      <ProjectsPage/>
    </Body>);
}

function Contact() {
  return (
    <Body>
      <Helmet>
          <title>{TITLE} | Contact</title>
      </Helmet>
      <ContactPage/>
    </Body>);
}

